/**
 * Message Domains - Centralized constants for message types (domains)
 */
export const MessageDomains = {
    MODAL: 'MODAL',
    FEATURE: 'FEATURE', 
    LANGUAGE: 'LANGUAGE',
    FLYOUT: 'FLYOUT',
    INTERFACE: 'INTERFACE',
    NAVIGATION: 'NAVIGATION',
    COLOR: 'COLOR',
    SYSTEM: 'SYSTEM',
    MOUSE: 'MOUSE',
} as const;

export type MessageDomain = typeof MessageDomains[keyof typeof MessageDomains];